import getPageComponent from 'common/routes/getPageComponent';
import {
  COOKIES_POLICY_PATH,
  FAQ_PATH,
  FORBIDDEN_PATH,
  LOGIN_PATH,
  MAIN_PAGE,
  PAYOUT_CONFIRMATION_PATH,
  PRIVACY_POLICY_PATH,
  RECOVERY_PATH,
  REGISTRATION_PATH,
  TERMS_PATH,
  TRUSTED_PARTNERS_PATH,
  VERIFICATION_PATH,
} from 'common/selectors/sidebar/common';
// eslint-disable-next-line local-rules/no-import-from-other-directory
import ForbiddenPage from 'common/pages/ForbiddenPage';
// eslint-disable-next-line local-rules/no-import-from-other-directory
import NotFoundPage from 'common/pages/NotFoundPage';
import { loggedTo } from 'common/helpers/routesAccess';
import { OVERVIEW_DASHBOARD_PATH } from 'common/selectors/sidebar/affiliates';

const DYNAMIC_COMPONENTS = {
  EmailVerificationPage: () => import('affiliates/pages/EmailVerificationPage'),
  LoginPage: () => import('common/pages/LoginPage'),
  PayoutConfirmationPage: () =>
    import('affiliates/pages/PayoutConfirmationPage'),
  RecoveryPage: () => import('affiliates/pages/RecoveryPage'),
  RegistrationPage: () => import('affiliates/pages/RegistrationPage'),
  MainPage: () => import('affiliates/pages/MainPage'),
  PrivacyPolicyPage: () => import('affiliates/pages/PrivacyPolicyPage'),
  CookiesPolicyPage: () => import('affiliates/pages/CookiesPolicyPage'),
  TermsPage: () => import('affiliates/pages/TermsPage'),
  FaqPage: () => import('affiliates/pages/FaqPage'),
  TrustedPartnersPage: () => import('affiliates/pages/TrustedPartnersPage'),
};

const loggedToAccount = loggedTo(OVERVIEW_DASHBOARD_PATH);

const SIMPLE_LAYOUT_ROUTES = [
  {
    exact: true,
    path: MAIN_PAGE,
    checkAccess: loggedToAccount,
    component: getPageComponent(DYNAMIC_COMPONENTS.MainPage),
  },
  {
    exact: true,
    path: LOGIN_PATH,
    checkAccess: loggedToAccount,
    component: getPageComponent(DYNAMIC_COMPONENTS.LoginPage),
  },
  {
    exact: true,
    path: `${VERIFICATION_PATH}/:username/:code`,
    component: getPageComponent(DYNAMIC_COMPONENTS.EmailVerificationPage),
  },
  {
    exact: true,
    path: `${PAYOUT_CONFIRMATION_PATH}/:username/:code`,
    component: getPageComponent(DYNAMIC_COMPONENTS.PayoutConfirmationPage),
    pageConfig: {
      title: 'Payout settings confirmation',
    },
  },
  {
    exact: true,
    path: `${REGISTRATION_PATH}/:userId?`,
    checkAccess: loggedToAccount,
    component: getPageComponent(DYNAMIC_COMPONENTS.RegistrationPage),
  },
  {
    exact: true,
    path: `${RECOVERY_PATH}/:hash?`,
    checkAccess: loggedToAccount,
    component: getPageComponent(DYNAMIC_COMPONENTS.RecoveryPage),
  },
  {
    exact: true,
    path: PRIVACY_POLICY_PATH,
    component: getPageComponent(DYNAMIC_COMPONENTS.PrivacyPolicyPage),
  },
  {
    exact: true,
    path: TERMS_PATH,
    component: getPageComponent(DYNAMIC_COMPONENTS.TermsPage),
  },
  {
    exact: true,
    path: FAQ_PATH,

    component: getPageComponent(DYNAMIC_COMPONENTS.FaqPage),
  },
  {
    exact: true,
    path: COOKIES_POLICY_PATH,
    component: getPageComponent(DYNAMIC_COMPONENTS.CookiesPolicyPage),
  },
  {
    exact: true,
    path: TRUSTED_PARTNERS_PATH,
    component: getPageComponent(DYNAMIC_COMPONENTS.TrustedPartnersPage),
  },
  { path: FORBIDDEN_PATH, component: ForbiddenPage },
  { path: '*', component: NotFoundPage },
];

export default SIMPLE_LAYOUT_ROUTES;
